// One accent per profile in a comparison, in order. The first two are the
// --amber / --steel pair the two-profile screen has always used, so a pair
// looks exactly as it did before there were four. Hex rather than var(),
// because d3 writes these as SVG attributes, where a custom property never
// resolves.
export const PROFILE_ACCENTS = [
  { color: "#D97E24", tint: "rgba(217, 126, 36, 0.14)" },
  { color: "#3E7A94", tint: "rgba(62, 122, 148, 0.13)" },
  { color: "#7C5FB8", tint: "rgba(124, 95, 184, 0.14)" },
  { color: "#C05577", tint: "rgba(192, 85, 119, 0.14)" }
];

export function accentAt(index) {
  return PROFILE_ACCENTS[index % PROFILE_ACCENTS.length];
}

// Inline custom properties, so a component styles one element per profile
// instead of carrying an A/B class pair per colour.
export function accentVars(accent) {
  return { "--accent": accent.color, "--accent-dim": accent.tint };
}
